import he from 'he';
import * as types from './types';
import Step from '../../../helpers/request/step';
import StepKindHelper from '../../../helpers/stepKind';
import * as filters from '../../../helpers/form/filters';

let StepRequest;

export const stepUpdateSubRequest = ({ dispatch }, data) => {
  const { quizId, stepId } = data;

  dispatch('optionConfigRequest', { quizId, stepId });
  dispatch('jumpConfigRequest', { quizId, stepId });
};

export const stepConfigRequest = ({ dispatch, state }, quizId = state.quiz_id) => {
  StepRequest = new Step({ quizId });
  dispatch('stepGet');
};

export const stepGet = ({ dispatch }) => {
  StepRequest.get()
     .then((response) => {
       dispatch('stepSet', { steps: response.data });
     });
};

export const stepSet = ({ commit, dispatch }, data) => {
  const steps = data.steps;

  commit(types.STEPS_SET, { steps });
  dispatch('stepSetActive', steps[0]);
};

export const stepSetActive = ({ commit, dispatch, state }, step) => {
  commit(types.STEP_SET_ACTIVE, { step });
  dispatch('optionSetActive', step.options);
  dispatch('jumpSetActive', step.jumps);
  dispatch('stepUpdateSubRequest', { quizId: state.quiz_id, stepId: step.id });
};

export const stepAdd = ({ state, commit, dispatch }, kind) => {
  let step = StepKindHelper.generate({ kind });

  step.position = state.list.length - 1;

  StepRequest.post(step, { showLoader: true })
    .then(response => {
      step = response.data;
      commit(types.STEP_ADD, { step });
      commit(types.STEP_UPDATE_POSITIONS);
      dispatch('stepSetActive', step);
    });
};

export const stepRemove = ({ commit, dispatch, state }) => {
  const step = state.active;
  StepRequest.delete(step.id, { showLoader: true })
    .then(() => {
      commit(types.STEP_REMOVE, step.position);
      commit(types.STEP_UPDATE_POSITIONS);
      dispatch('optionResetActive');
      dispatch('modalClose');
      if (state.list.length > 0) {
        dispatch('stepSetActive', state.list[0]);
      }
    }
  );
};

export const stepUpdateMultipleAnswers = ({ commit }, data) => {
  StepRequest.put(data.id, { multiple_answers: data.event.target.checked }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_MULTIPLE_ANSWER, response.data));
};

export const stepUpdateFormHtml = ({ commit }, data) => {
  const formHtml = filters.standard(data.html);
  const customizedForm = false;
  const config = { showLoader: true };

  StepRequest.put(data.id, {
    form_html: formHtml,
    original_form_html: data.html,
    customized_form: customizedForm,
  }, config)
    .then((response) => {
      commit(types.STEP_UPDATE_FORM_HTML, response.data);
      commit(types.STEP_UPDATE_ORIGINAL_FORM_HTML, response.data);
      commit(types.STEP_UPDATE_FORM_CUSTOMIZED, response.data);
    });
};

export const stepUpdateCustomizedForm = ({ commit, state }, data) => {
  const originalFormHtml = he.decode(state.active.original_form_html);
  const customizedForm = data.event.target.checked;
  const config = { showLoader: true };

  let formHtml = filters.standard(originalFormHtml);

  if (customizedForm) {
    formHtml = filters.format(originalFormHtml);
  }

  StepRequest.put(data.id, {
    customized_form: customizedForm,
    form_html: formHtml,
  }, config)
    .then((response) => {
      commit(types.STEP_UPDATE_FORM_CUSTOMIZED, response.data);
      commit(types.STEP_UPDATE_FORM_HTML, response.data);
    });
};

export const stepUpdateRedirectAutomatic = ({ commit }, data) => {
  StepRequest.put(data.id, { redirect_automatic: data.event.target.checked }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_REDIRECT_AUTOMATIC, response.data));
};

export const stepUpdateRedirectUrl = ({ commit }, data) => {
  StepRequest.put(data.id, { redirect_url: data.event.target.value }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_REDIRECT_URL, response.data));
};

export const stepUpdateRedirectButtonText = ({ commit }, data) => {
  StepRequest.put(data.id, { redirect_button_text: data.event.target.value }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_REDIRECT_BUTTON_TEXT, response.data));
};

export const stepUpdateTitle = ({ commit }, data) => {
  StepRequest.put(data.id, { title: data.event.target.value }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_TITLE, response.data));
};

export const stepUpdateRedirectEmailService = ({ commit }, data) => {
  const config = { showLoader: true };

  StepRequest.put(data.id, { redirect_email_service: data.event.target.checked }, config)
    .then(response => commit(types.STEP_UPDATE_REDIRECT_EMAIL_SERVICE, response.data));
};

export const stepUpdateOrder = ({ state, commit }, data) => {
  const list = state.list;
  const config = { showLoader: true };

  commit(types.STEPS_SET, { steps: data.list });

  StepRequest.ordinate(data.event.item.id, { destination_position: data.event.newIndex }, config)
    .then(response => commit(types.STEPS_SET, { steps: response.data }))
    .catch(() => commit(types.STEPS_SET, { steps: list }));
};

export const stepChangeDescriptionVisibity = ({ commit }, data) => {
  const config = { showLoader: true };

  StepRequest.put(data.id, { description_visibility: data.event.target.checked }, config)
    .then((response) => commit(types.STEP_UPDATE_DESCRIPTION_VISIBILITY, response.data));
};

export const stepUpdateDescriptionText = ({ commit }, data) => {
  StepRequest.put(data.id, { description_text: data.event.target.value }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_DESCRIPTION, response.data));
};

export const stepDuplicate = ({ commit, dispatch, state }, quantity) => {
  const step = state.active;
  StepRequest.duplicate(step.id, { quantity }, { showLoader: true })
    .then(response => {
      commit(types.STEP_PUSH, { steps: response.data });
      commit(types.STEP_UPDATE_POSITIONS);
      dispatch('stepSetActive', response.data[0]);
      dispatch('modalClose');
    });
};

export const stepUpdateWelcomeActive = ({ commit, dispatch }, data) => {
  const welcomeActive = data.event.target.checked;

  StepRequest.put(data.id, { welcome_active: welcomeActive }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_WELCOME_ACTIVE, response.data));
};

export const stepUpdateWelcomeOption = ({ commit }, data) => {
  StepRequest.put(data.id, { welcome_option: data.event.target.value }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_WELCOME_OPTION, response.data));
};

export const stepUpdateTextRequired = ({ commit }, data) => {
  StepRequest.put(data.id, { required: data.event.target.checked }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_TEXT_REQUIRED, response.data));
};

export const stepUpdateTextSize = ({ commit }, data) => {
  let textSize = 'short';

  if (data.event.target.checked) {
    textSize = 'long';
  }

  StepRequest.put(data.id, { text_size: textSize }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_TEXT_SIZE, response.data));
};

export const stepUpdateTextPlaceholder = ({ commit }, data) => {
  StepRequest.put(data.id, { placeholder_text: data.placeholderText }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_TEXT_PLACEHOLDER, response.data));
};

export const stepUpdateNextButtonText = ({ commit }, data) => {
  StepRequest.put(data.id, { next_button_text: data.event.target.value }, { showLoader: true })
    .then(response => commit(types.STEP_UPDATE_NEXT_BUTTON_TEXT, response.data));
};

export const stepSetPreview = ({ commit }, step) => {
  commit(types.STEP_SET_PREVIEW, { step });
};

export const stepUpdateStyle = ({ commit, state, dispatch }, { item, rule, value }) => {
  const styles = state.preview.styles;

  commit(types.STEP_UPDATE_STYLE, { item, rule, value });
  StepRequest.put(state.preview.id, { styles }, { showLoader: true })
    .then(response => commit(types.STEP_SET_STYLES, response.data.styles))
    .catch(() => commit(types.STEP_SET_STYLES, styles));
};

export const stepPreviewStyleChange = ({ commit }, { item, rule, value }) => {
  commit(types.STEP_UPDATE_STYLE, { item, rule, value });
};

export const stepResetState = ({ commit }) => {
  commit(types.STEP_RESET_STATE);
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/step/actions.js
 **/